import type {Features} from '@/types/features.types';

export const myparcel_nederland: Features = {
  debug: {
    websockets: false,
  },
  events: {
    sknj: {
      endOfYear: false,
    },
  },
  errors: false,
  portal: {
    events: false,
  },
  page: {
    addresses: {
      import: true,
    },
    collectTrip: false,
    dashboard: true,
    deliveries: true,
    orders: {
      create: false,
      import: false,
      overview: false,
      editPackageForm: false,
    },
    prices: {
      scale: {
        dhl: true,
        dpd: true,
        postnl: true,
      },
    },
    products: {
      import: false,
    },
    settings: {
      shop: {
        emails: false,
        general: false,
        orders: true,
        returns: {
          index: false,
        },
        rules: {
          index: false,
          orders: false,
          shipments: false,
          returns: false,
        },
        // Feature flag is NOT used to turn on the sales-channel features. It is used to bypass the fulfilment checks to access saleschannel.
        salesChannels: false,
        trackTrace: false,
      },
    },
    shipments: {
      newShipmentOverview: false,
      newCreateShipmentForm: false,
      newImportShipmentForm: false,
      newCreateReturnShipmentForm: false,
    },
    users: false,
  },
  settings: {
    accountSettingsLegacy: false,
  },
  trackAndTraceModal: false,
} as const;
